import { Base } from '@itsrever/design-system'
import { useTranslation } from 'react-i18next'
import {
  GroupNangoConnection,
  connectionLabel
} from '@/domain/nango-connection'

const {
  Button,
  DialogRoot,
  DialogPortal,
  DialogBackdrop,
  DialogPopup,
  DialogTitle,
  DialogDescription,
  DialogCloseButton,
  DialogHeader,
  DialogFooter,
  Callout
} = Base

interface DeleteCredentialDialogProps {
  connection?: GroupNangoConnection
  deleting: boolean
  onClose: () => void
  onDelete: () => void
}

export const DeleteCredentialDialog: React.FC<DeleteCredentialDialogProps> = ({
  connection,
  deleting,
  onClose,
  onDelete
}) => {
  const { t } = useTranslation()

  if (!connection) return null
  // Disabled stores count too: deleting unassigns the credential from all of them.
  const assigned = connection.linkedEcommerceIds.length

  return (
    <DialogRoot
      open
      onOpenChange={(open) => {
        if (!open) onClose()
      }}
    >
      <DialogPortal>
        <DialogBackdrop />
        <DialogPopup size="sm">
          <div className="flex flex-col gap-4">
            <DialogCloseButton />
            <DialogHeader>
              <DialogTitle>
                {t('nango_credentials.delete_dialog.title', {
                  name: connectionLabel(connection)
                })}
              </DialogTitle>
              <DialogDescription>
                {t('nango_credentials.delete_dialog.description')}
              </DialogDescription>
            </DialogHeader>

            {assigned > 0 ? (
              <Callout tone="danger">
                <p className="text-xs">
                  {t('nango_credentials.delete_dialog.warning_assigned', {
                    count: assigned
                  })}
                </p>
              </Callout>
            ) : null}

            <DialogFooter>
              <Button type="button" variant="secondary" onClick={onClose}>
                {t('nango_credentials.delete_dialog.cancel')}
              </Button>
              <Button
                type="button"
                variant="destructive"
                loading={deleting}
                onClick={onDelete}
              >
                {t('nango_credentials.delete_dialog.submit')}
              </Button>
            </DialogFooter>
          </div>
        </DialogPopup>
      </DialogPortal>
    </DialogRoot>
  )
}
